export function homePageScroll($: JQueryStatic): void {
    $(".homepage__scroll-btn-hero").on("click", function () {
        const heroHeight: number | null | undefined = $(".homepage__hero").innerHeight();

        $("html, body").animate(
            {
                scrollTop: heroHeight,
            },
            1500
        );
    });
}

export function moveLinkedInButton($: JQueryStatic): void {
    const linkedIn: JQuery = $(
        ".bio .attrax-social-hub-profile-widget .sh-linkedin-button"
    ).detach();

    $(".bio .attrax-user-profile-contact-buttons-widget__buttons").append(
        linkedIn
    );
}

export function moveFilterButton($: JQueryStatic): void {
    $(".optionfiltergroup").each(function (idx: number, val: HTMLElement) {
        const clearBtn: JQuery = $(val)
            .find(".job-filter-clear-group-btn")
            .detach();

        $(val).find(".apply-filters-btn-container").append(clearBtn);
    });
}

export function repositionBioModal($: JQueryStatic): void {
    const bioModal = $(
        ".attrax-social-hub-profile-widget .attrax-popup-modal"
    ).detach();

    $("body").append(bioModal);
}

export function shortlistRedirect($: JQueryStatic): void {
    $(".inline-shortlist-widget").on("click", function () {
        window.location.href = "/candidateshortlist";
    });
}

export function showValidationIfTrue($: JQueryStatic): void {
    $(".attrax-login-widget__btn-login").on("click", function () {
        if (
            $(".attrax-login-widget__validation-summary").children().length >= 1
        ) {
            $(".attrax-login-widget__validation-summary").css(
                "display",
                "block"
            );
        }
    });
}

export function createStickyApplyHeading($: JQueryStatic): void {
    if ($("body").hasClass("job-details")) {
        const jobTitle = $(".title-widget .header__text").text();

        $(".stick-apply__heading").text(jobTitle);
    }
}

export const moveKeyword = () => {
    const keyword: HTMLElement | null = document?.querySelector(
        "#keyword-option-wrapper"
    );

    if (!keyword) return;

    const container = document.querySelector(".job-results__hero");
    container?.append(keyword);

    keyword.style.display = "flex";
};

export function moveSendCvModal($: JQueryStatic): void {
    const sendCvForm = $(
        ".bio .attrax-user-profile-contact-buttons-widget__sendcv-modal"
    ).detach();

    $(".bio").append(sendCvForm);
}

export function removeFooterAutocomplete($: JQueryStatic): void {
    $(".footer__search .attrax-form-item__input").on("focus", function () {
        $(".autocomplete-suggestions").addClass("footer-focused");
    });

    $(".footer__search .attrax-form-item__input").on("blur", function () {
        setTimeout(() => {
            $(".autocomplete-suggestions").removeClass("footer-focused");
        }, 2000);
    });
}

export function showExpiredVacancyBanner($: JQueryStatic): void {
    const isExpired = $("body.job-details .validation-summary-errors").length;

    if (isExpired >= 1) {
        $(".corp-expired-vacancy").addClass("show");
    }
}

export const addClearbtn = () => {
    const widgets: string[] = [
        "content-types-widget",
        "tags-widget",
        "attrax-post-filters",
    ];

    widgets.forEach((widget) => {
        if (document.querySelector(".post-results ." + widget)) {
            const widgetList: HTMLElement | null | undefined = document
                .querySelector(".post-results ." + widget)
                ?.querySelector("ul");
            const clearli: HTMLElement = document.createElement("li");
            clearli.classList.add(`${widget}__clear-btn-li`);
            const clearBTn: HTMLElement = document.createElement("a");
            clearBTn.classList.add(`${widget}__clear-btn`);
            clearBTn.classList.add(`attrax-button`);
            clearBTn.setAttribute("href", "/posts");
            clearBTn.setAttribute(
                "aria-label",
                "click here to clear selected types"
            );
            clearBTn.textContent = "Clear";
            clearli.appendChild(clearBTn);
            widgetList?.appendChild(clearli);
        }
    });
};

export const removeNonBreakingSpaceFromJobDetails = () => {
    const jobDetails: HTMLDivElement | null = document.querySelector(
        ".job-details__main-content"
    );
    if (document.body.classList.contains("job-details") && jobDetails) {
        const emptyParagraphs: NodeListOf<HTMLParagraphElement> =
            jobDetails.querySelectorAll<HTMLParagraphElement>("p");
        emptyParagraphs.forEach((paragraph) => {
            if (paragraph.textContent && paragraph.textContent.length <= 1) {
                paragraph.remove();
            }
        });
    }
};

export const removeSocialWidgetIfEmpty = () => {
    const jobDetails: HTMLDivElement | null = document.querySelector(
        ".job-details__main-content"
    );

    if (document.body.classList.contains("job-details") && jobDetails) {
        const socialWidget: HTMLDivElement | null = jobDetails.querySelector('.social-hub-profile-widget');

        if (!socialWidget) return;

        socialWidget.childElementCount === 0 ? socialWidget.style.opacity = "0" : socialWidget.style.opacity = "1";
    }
};

export const addFilterTextHeadingJobResults = () => {
    if (!document.body.classList.contains("job-results")) return;

    const filterHeading: HTMLElement | null = document.querySelector("#filter-header");

    if (!filterHeading) return;

    if (window.innerWidth < 768) {
        filterHeading.innerHTML =
            "<span aria-label='mobilefilter toggle' role='button'>{{js.job-results-filter-heading}}</span>";

        filterHeading.style.opacity = "1";
    }
};

export const showAuthorDetailsIfAuthor = () => {
    const authorWidget: HTMLElement | null = document.querySelector(
        ".author-details-widget"
    );
    const page = document.querySelector(".post-details");

    if (!page || !authorWidget) return;

    const noAuthor = authorWidget?.querySelector<HTMLElement>(".user-invisible");

    if (!noAuthor && authorWidget) {
        authorWidget.style.display = "block";
    }
};
